import { createMigrate } from 'redux-persist';
import _ from 'lodash';

import { storage } from '../persistStorage';
import { defaultPalette } from '../../pages/Dashboards/DashboardColorPalettes';
import { DASHBOARD_ID as ADHERENDE_DASHBOARD_ID } from '../../pages/Dashboard/Dashboard';

const removeIsResizableTrue = layout => {
  return layout.map(({ isResizable, ...widgetProps }) => {
    if (isResizable === false) {
      return { ...widgetProps, isResizable: false };
    }
    return widgetProps;
  });
};

// https://stackoverflow.com/questions/39085399/lodash-remove-items-recursively
function deepOmit(object, keysToOmit) {
  const keysToOmitIndex =  _.keyBy(Array.isArray(keysToOmit) ? keysToOmit : [keysToOmit] ); // create an index object of the keys that should be omitted

  function omitFromObject(obj) { // the inner function which will be called recursivley
    return _.transform(obj, function(result, value, key) { // transform to a new object
      if (key in keysToOmitIndex) { // if the key is in the index skip it
        return;
      }

      result[key] = _.isObject(value) ? omitFromObject(value) : value; // if the key is an object run it through the inner function - omitFromObject
    })
  }
  
  return omitFromObject(object); // return the inner function result
}

const migrations = {
  0: previousVersionState => ({
    dashboardFilters: previousVersionState.dashboardFilters,
    dashboardLayouts: Object.entries(previousVersionState.dashboardLayouts).map(([dashboardId, layouts]) => {
      return {
        [dashboardId]: {
          l: removeIsResizableTrue(layouts.l),
          m: removeIsResizableTrue(layouts.m),
          s: removeIsResizableTrue(layouts.s),
        },
      };
    }),
  }),
  1: previousVersionState => ({
    dashboardFilters: previousVersionState.dashboardFilters,
    dashboardLayouts: previousVersionState.dashboardLayouts,
    configuration: { allDashboards: { colorPalette: defaultPalette } },
  }),
  2: previousVersionState => ({
    dashboardFilters: {
      ...previousVersionState.dashboardFilters,
      [ADHERENDE_DASHBOARD_ID]: previousVersionState.dashboardFilters[ADHERENDE_DASHBOARD_ID].map(filter => {
        if (filter.id === 'PatientsState' || filter.id === 'ActiveMonthlyPillboxUsers') {
          return { ...filter, checked: false };
        }
        return filter;
      }),
    },
    dashboardLayouts: previousVersionState.dashboardLayouts,
    configuration: previousVersionState.configuration,
  }),
  3: previousVersionState => ({
    dashboardFilters: previousVersionState.dashboardFilters,
    dashboardLayouts: previousVersionState.dashboardLayouts,
    configuration: deepOmit(
      previousVersionState.configuration,
      ['type', 'name', 'label', 'defaultValue', 'options', 'canBeSetByDashboard'],
    ),
  }),
};

export const dashboardStateConfig = {
  key: 'dashboardState',
  version: 3,
  migrate: createMigrate(migrations, { debug: false }),
  storage,
  blacklist: ['editMode'],
};
